import { createI18n } from '@rendimees24/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';


import { App } from './App';
import { initFirebase } from './services/firebase';
import { startInstallCapture } from './services/pwaInstall';
import { bootLocale } from './lib/accountLocale';
import { syncDocumentLang } from './lib/documentLang';
import { startSyncQueue } from './services/syncQueue';

// Initialize Firebase + i18n before first render.
initFirebase();
// PWA-4 — start replaying any field actions left queued from a previous session
// (offline check-out, photos) and listen for reconnects. Must run AFTER
// initFirebase: the drainer flushes Firestore's own write queue first.
startSyncQueue();
// Must run before first paint: `beforeinstallprompt` fires once, early, and
// is lost unless something calls preventDefault() on it.
startInstallCapture();
const i18n = createI18n({
  // Pre-auth only; AuthContext switches to the signed-in person's language.
  initialLocale: bootLocale(),
  // admin-web now hosts the admin / client / worker / partner shells in one app.
  namespaces: ['common', 'admin', 'client', 'worker', 'partner'],
});
// <html lang> follows every language change from here on (WCAG 3.1.1).
syncDocumentLang(i18n);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
